export default function formatDate(d: Date) {
  return `${d.getDate()} • ${
    d.getMonth() + 1
  } • ${d.getFullYear().toString().substr(-2)}`
}
